export const superSection = () => {

  if (document.querySelector('.super')) {
    gsap.registerPlugin(ScrollTrigger);
    function setMaxTitleHeight(itemSelector, containerSelector) {
      const items = document.querySelectorAll(itemSelector);
      const container = document.querySelector(containerSelector);

      let maxHeight = 0;
      items.forEach(item => {
        const height = item.scrollHeight;
        if (height > maxHeight) maxHeight = height;
      });

      container.style.height = maxHeight + 'px';
    }

    setMaxTitleHeight('.super__title', '.super__titles-wrapper');
    setMaxTitleHeight('.super__text', '.super__texts-wrapper');



    (function initOemAnimation() {
      const section   = document.querySelector('.super');
      const images    = gsap.utils.toArray('.super__big-images img');
      const imagesSmall    = gsap.utils.toArray('.super__images img');
      const texts     = gsap.utils.toArray('.super__text');
      const titles     = gsap.utils.toArray('.super__title');

      if (!section || !images.length) return;

      const TOTAL = images.length;

      gsap.set(images, { position: 'absolute', top: 0, left: 0, width: '100%' });

      images.forEach((img, i) => {
        gsap.set(img, { yPercent: i === 0 ? 0 : 100, opacity: i === 0 ? 1 : 0 });
      });

      gsap.set(texts, { position: 'absolute', top: 0, left: 0, width: '100%' });
      gsap.set(titles, { position: 'absolute', top: 0, left: 0, width: '100%' });
      let start = 'bottom bottom'
      if (window.innerWidth <= 999) {
        start = 'top top'
      }
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: section,
          start: start,
          end: () => `+=${window.innerHeight * (TOTAL - 1)}`,
          pin: true,
          scrub: 1,
          anticipatePin: 1,
          toggleActions: 'play none none reverse',
          onEnter: () => document.querySelector('header').classList.add('header-anim'),
          onLeave: () => document.querySelector('header').classList.remove('header-anim'),
          onEnterBack: () => document.querySelector('header').classList.add('header-anim'),
          onLeaveBack: () => document.querySelector('header').classList.remove('header-anim'),
          onUpdate: (self) => {
            const index = Math.round(self.progress * (TOTAL - 1)) + 1;
            numbers.textContent = String(index).padStart(2, '0');
          },
        },
      });

      const numbers = document.querySelector('.super__numbers span:first-child');

      for (let i = 0; i < TOTAL - 1; i++) {
        tl
          .to(images[i],    { yPercent: -100, opacity: 0, duration: 1, ease: 'power2.inOut' }, i)
          .to(imagesSmall[i],    { scale: 0, opacity: 0, duration: 1, ease: 'power2.inOut' }, i)
          .fromTo(images[i + 1],
            { yPercent: 100, opacity: 0 },
            { yPercent: 0,   opacity: 1, duration: 1, ease: 'power2.inOut' }, i)
          .fromTo(imagesSmall[i + 1],
            { scale: 0, opacity: 0 },
            { scale: 1,   opacity: 1, duration: 1, ease: 'power2.inOut' }, i)
          .to(texts[i],     { yPercent: -100, opacity: 0, duration: 1, ease: 'power2.inOut' }, i)
          .fromTo(texts[i + 1],
            { yPercent: 100, opacity: 0 },
            { yPercent: 0,   opacity: 1, duration: 1, ease: 'power2.inOut' }, i)
          .to(titles[i],     { yPercent: -100, opacity: 0, duration: 1, ease: 'power2.inOut' }, i)
          .fromTo(titles[i + 1],
            { yPercent: 100, opacity: 0 },
            { yPercent: 0,   opacity: 1, duration: 1, ease: 'power2.inOut' }, i)
          .to(numbers, {
            duration: 0.1,
            onComplete: () => {
              numbers.textContent = String(i + 2).padStart(2, '0');
            }
          }, i + 0.5);
      }
      let lastWidth = window.innerWidth;
      window.addEventListener('resize', () => {
        if (window.innerWidth === lastWidth) {
          return;
        }
        lastWidth = window.innerWidth;
        ScrollTrigger.refresh();
      });
    })();
  }
}